var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSluch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7713 5.57141H19.2289C11.6862 5.57141 5.57153 11.686 5.57153 19.2288V58.7711C5.57153 66.3139 11.6862 72.4286 19.2289 72.4286H58.7713C66.314 72.4286 72.4287 66.3139 72.4287 58.7711V19.2288C72.4287 11.686 66.314 5.57141 58.7713 5.57141Z",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9351 28.4638C25.9351 21.1435 31.9548 15.229 39.3148 15.4032C46.0952 15.5636 51.9252 21.4143 52.0615 28.1964C52.127 31.4581 50.9955 34.4559 49.0775 36.7776C47.0559 39.2252 45.7295 42.1729 45.1103 45.2863L43.7701 52.0115C43.0767 55.4888 40.0254 57.9933 36.4791 57.9933C33.6296 57.9933 30.8975 56.8618 28.8828 54.8472L28.7155 54.6799",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.028 28.4638C46.028 24.4397 42.6283 21.1935 38.549 21.4505C34.8268 21.6851 31.9722 24.8657 31.9722 28.5966C31.9722 30.1248 32.5793 31.5909 33.6591 32.6707L36.5068 35.5184C38.092 37.1036 38.092 39.6719 36.5068 41.257L34.6491 43.1147C33.3141 44.4497 33.3141 46.6127 34.6491 47.9477L36.9915 50.2901",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7144 22.2857L68.449 9.55103",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55103 68.449L29.449 48.551",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSluch);
export default __webpack_public_path__ + "static/media/sluch.eed1e72a9ae9d43334367d08a8a5a583.svg";
export { ForwardRef as ReactComponent };